import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormEditSummaryItem } from './FormEditSummaryItem';
import { useAttachmentsComponent } from '../../hooks/useAttachmentsComponent';
import { CustomAttachmentField } from '../../../../../components/incidentForm/fields/customAttachment/customAttachmentField';
import constants from '../../../../../config/api/constants';

export const EditSummaryAttachmentItem = ({ field, onFinish, parents }) => {
  const [fieldData, setFieldData] = useState(field);
  const { uploadAttachment } = useAttachmentsComponent({
    idInput: field.idInput,
    parents,
  });

  const onChange = (value) => {
    setFieldData((current) => ({
      ...current,
      value,
    }));
  };

  const handleFinish = async (result) => {
    if (!result?.save) {
      onFinish(result);
      return;
    }
    const uploadedValue = await Promise.all(
      (result.newValue?.value ?? []).map(async (item) => {
        if (item.url) return { fileName: item.fileName, url: item.url };
        const { fileKey } = await uploadAttachment(item.file);
        const url = constants.s3Bucket && !fileKey.startsWith(`${constants.s3Bucket}/`)
          ? `${constants.s3Bucket}/${fileKey}`
          : fileKey;
        return { fileName: item.fileName, url };
      }),
    );
    onFinish({ save: true, newValue: { value: uploadedValue } });
  };

  return (
    <FormEditSummaryItem showActionsInTitle fullWidthInput onFinish={handleFinish} field={fieldData}>
      <CustomAttachmentField field={fieldData} onChange={onChange} value={fieldData.value} />
    </FormEditSummaryItem>
  );
};

EditSummaryAttachmentItem.propTypes = {
  field: PropTypes.object,
  onFinish: PropTypes.func,
  parents: PropTypes.arrayOf(PropTypes.string),
};
